module.exports = __webpack_public_path__ + "img/info2_.6860a752.png";